// extracted by mini-css-extract-plugin
module.exports = {"labelsContainer":"styles_labelsContainer__1UOoh","submitButton":"styles_submitButton__2D9Bn"};